import React, { Component } from "react";
import {formataData} from '../../utils/formatadorData';
import './Contract.css';

export const ContractDetails =

	class extends Component {

		render() {
            const contrato = this.props.contrato;
			return (
				<fieldset>
                    <legend>Contrato</legend>
                    <div className="row">
                        <div className="col-md">
                            <div className="field">
                                <div className="input">
                                    <label>Tipo de Contrato:</label>
                                    {contrato.nomeTipoContrato}
                                </div>
                            </div>
                        </div>
                        <div className="col-md">
                            <div className="field">
                                <div className="input">
                                    <label>Contrato do Serpro:</label>
                                    {contrato.contratoSerpro ? 'Sim' : 'Não'}
                                </div>
                            </div>
                        </div>
                    </div>	
                    <div className="row">
                        <div className="col-md">
                            <div className="field">
                                <div className="input">
                                    <label>Nome:</label>
                                    {contrato.nomeContrato}
                                </div>
                            </div>
                        </div>
                        <div className="col-md">
                            <div className="field">
                                <div className="input">
                                    <label>Item Faturável:</label>
                                    {contrato.nomeItemFaturavel}
                                </div>
                            </div>
                        </div>
                    </div>	
                    <div className="row">
                        <div className="col-md">
                            <div className="field">
                                <div className="input">
                                    <label>Início Vigência:</label>
                                    {formataData(contrato.inicioVigencia)}
                                </div>
                            </div>
                        </div>
                        <div className="col-md">
                            <div className="field">
                                <div className="input">
                                    <label>Fim Vigência:</label>
                                    {formataData(contrato.fimVigencia)}
                                </div>
                            </div>
                        </div>
                    </div>	
                </fieldset>
			);
		}

	}

